import React, { useContext } from 'react';
import { useParams } from 'react-router-dom';
import { ritzDataContext, selectProjectById } from '@moderepo/mode-data-state-ritz';
import { Grid } from '@material-ui/core';
import { useRitzTranslation } from '../../utils/customHooks';
import { ProjectSettingsContainer } from '../projects/ProjectSettingsContainer';
import { RCProjectSettingsContainer } from './RCProjectSettingsContainer';
import { RCTicketSystemSettingsContainer } from './RCTicketSystemSettingsContainer';
import { RCSlackSettingsContainer } from './RCSlackSettingsContainer';


export const RCProjectSettingsPage: React.FC = () => {
    const params = useParams();
    const projectId = Number(params.projectId);
    const { state:dataState } = useContext(ritzDataContext);
    const project = selectProjectById(dataState, projectId);
    const { trans } = useRitzTranslation(project);

    return (
        <div className="page-main-content">
            <div className="title-bar">
                <div className="title-bar-item title-text">
                    <div className="page-title">
                        {trans('page.title.project_settings')}
                    </div>
                    <div className="page-subtitle">
                        {trans('page.subtitle.project_settings')}
                    </div>
                </div>
            </div>

            <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                    <ProjectSettingsContainer projectId={projectId} />
                </Grid>
                <Grid item xs={12} md={6}>
                    <RCProjectSettingsContainer className="match-height" projectId={projectId} />
                </Grid>
                <Grid item xs={12}>
                    <RCTicketSystemSettingsContainer projectId={projectId} />
                </Grid>
                <Grid item xs={12}>
                    <RCSlackSettingsContainer projectId={projectId} />
                </Grid>
            </Grid>
        </div>
    );
};
